import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import VueCustomElement from 'vue-custom-element';
import GoogleMaps2 from '../Common/GoogleMaps2.vue';
import { vueCustomElementOptions } from 'static-components/src/vue-customelement-options';
import { STATE, StateHelper } from "Helper/StateHelper";
var initializeGoogleMaps2 = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                Vue.use(VueCustomElement);
                return [4 /*yield*/, StateHelper.instance.readyStates(STATE.TRANSLATOR, STATE.INPUT_VALUE_SETUP_PACKAGE)];
            case 1:
                _a.sent();
                Vue.customElement('c-gmap2', (new GoogleMaps2().$options), vueCustomElementOptions);
                return [2 /*return*/];
        }
    });
}); };
export default initializeGoogleMaps2;
